module.exports = __webpack_public_path__ + "PR6-04a8431b.webp";